import { useCallback, useContext } from "react";
import { AllLayoutCellMapContext, VisibleLayoutCellMapContext, } from "./LayoutCellMapContext";
/**
 * Return current cell
 *
 * ⚠️ Won't work in the layout editor
 * @param options
 * @returns
 */
export function useLayoutCellByIdFinder() {
    const allCellMap = useContext(AllLayoutCellMapContext);
    const visibleCellMap = useContext(VisibleLayoutCellMapContext);
    return useCallback((options) => {
        const { layoutCellId, visibleLayoutOnly } = options;
        const cellMap = visibleLayoutOnly ? visibleCellMap : allCellMap;
        return cellMap.get(layoutCellId);
    }, [allCellMap, visibleCellMap]);
}
//# sourceMappingURL=useLayoutCellByIdFinder.js.map